import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

export const SummaryDocument = ({ documentData }) => (
	<Document>
		<Page size="A4" style={styles.page}>
			{documentData.map((item, itemIndex) => {
				return (
					<View key={itemIndex} style={styles.sectionBottom}>
						<Text style={styles.heading}>{item.title}</Text>
						{item.bodyContent.map((key, index) => {
							return (
								<View key={index} style={styles.firstSubView}>
									<Text style={styles.bulletText}>•</Text>
									<Text style={styles.subText}>{key}</Text>
								</View>
							);
						})}
					</View>
				);
			})}
		</Page>
	</Document>
);

const styles = StyleSheet.create({
	page: {
		backgroundColor: '#FFFFFF',
		padding: 10,
	},
	section: {
		marginHorizontal: 10,
		marginVertical: 5,
	},
	subSection: {
		marginHorizontal: 10,
	},
	sectionBottom: {
		marginBottom: 10,
		marginHorizontal: 10,
	},
	docTitle: {
		fontSize: 16,
		fontWeight: 'bold',
		color: '#000000',
		textAlign: 'center',
	},
	heading: {
		fontSize: 14,
		fontWeight: 'bold',
		color: '#28696D',
	},
	subHeading: {
		fontSize: 12,
		color: '#28696D',
		fontWeight: '700',
	},
	text: {
		fontSize: 10,
		color: '#444444',
	},
	subText: {
		fontSize: 10,
		color: '#444444',
		paddingTop: '2px',
	},
	bulletText: {
		marginHorizontal: 5,
		fontSize: 10,
		color: '#000000',
		paddingTop: '2px',
	},
	subView: {
		flexDirection: 'row',
		paddingRight: 5,
	},
	firstSubView: {
		flexDirection: 'row',
		paddingTop: 5,
	},
});
